const addOrderAddressMixin = {
    data: function () {
        return {
            saveAddress: false,
            useBillingDetails: true,
            countries: vueCheckoutAddressPage_DATA.countries,
            address: {}
        }
    },
    validations: {
        address: {
            firstName: {
                required
            },
            lastName: {
                required
            },
            emailAddress: {
                required,
                email 
            },
            phoneNumber: {
                required
            },
            line1: {
                required
            },
            city: {
                required
            },
            postalCode: {
                required
            },
            countryId: {
                required
            }
        }
    },
    methods: {
        getCheckoutAddress: function () {
            const vm = this;

            const data = {
                addressType: vueCheckoutAddressPage_DATA.addressType
            };

            vm.getCheckoutAddressApi(data)
                .then(function (response) {
                    if (!response)
                        return;

                    vm.address = response.data.content;

                    if (vm.address.addressId !== 0) {
                        vm.showAddressForm = true;
                    }
                });
        }
    }
}